
import React, { FC, Fragment, useEffect, useRef, useState } from 'react'
import { Box, Button, Checkbox, CircularProgress, FormControlLabel, Grid, Link, IconButton, InputAdornment, TextField, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import logo from '../../assets/images/pool.jpeg';
import { ArrowDropDown, ArrowBackOutlined, VisibilityOff, RemoveRedEye } from '@mui/icons-material';

import { UserProps } from '../../types/user';
import { Api, buildPhone } from '../../helpers'
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { Connect, mapDispatchToProps, mapStateToProps } from '../../Redux';
import { useNavigate } from 'react-router-dom';
import Show from '../common/show';
import ChangeSignInWith from './changeSignInWith';
import CodeVerification from '../common/codeVerification';
import QRCode from 'react-qr-code';
import { onSocketMessage, onSocketOpen, sendSocketData } from '../../helpers/socket';
import { QR_LOGIN_PREFIX } from '../../configs';

export interface inputProps {
    label?: string,
    value: string | boolean,
    error?: string | null,
    field?: string
    type?: string
    hidePass?: boolean
}

export type Page = 'Sign In' | 'Sign Up' | 'Forgot Password' | 'resetPass' | 'codeVerification'

const codeVer = 'codeVerification'

export type loginType = 'Phone' | 'Username'

const PRIMARY = '#006B46'
const PRIMARY_DARK = '#00432D'

const SIDE_FEATURES = [
    { icon: '🎱', text: 'Find and book pool tables near you' },
    { icon: '⚡', text: 'Pay per game, no membership needed' },
    { icon: '🏆', text: 'Join tournaments and climb the rankings' }
]

interface StateProps {
    currentPage: Page,
    Username: inputProps,
    Password: inputProps,
    NewPass: inputProps,
    Phone: inputProps,
    ConfirmPass: inputProps,
    loginWith: loginType,
    previousPage: Page | null,
    showPass: boolean,
    country: {
        flag: string,
        code: string,
        name: string
    },
    forgotPinCode: string | undefined
    submitting: boolean
    openDialog: boolean
    instantPlay: boolean
    qrSessionId: string | null
    verifyUserId: string | undefined
}

interface Props {
    setRedux?: (data: any) => void
    User?: UserProps
    loggedIn?: boolean
}

export const frgtPass = 'Forgot Password'

const initialInputs = {
    Username: { label: 'Username', value: '', type: 'Username', field: 'Username' },
    Password: { label: 'Password', value: '', type: 'password', field: 'Password' },
    NewPass: { label: 'New Password', value: '', type: 'password', field: 'NewPass' },
    ConfirmPass: { label: 'Confirm Password', value: '', type: 'password', field: 'ConfirmPass' },
    Phone: { label: 'Phone', value: '', field: 'Phone' },
    AgreeToTerms: { label: 'Agree To Terms & Conditions', value: false, type: 'checkbox', field: 'AgreeToTerms' }
}



const Auth: FC<Props> = ({
    setRedux,
    User,
    loggedIn
}) => {
    const navigate = useNavigate();

    const [state, setState] = useState<StateProps>({
        currentPage: 'Sign In',
        ...initialInputs,
        showPass: false,
        previousPage: null,
        loginWith: 'Username',
        country: {
            flag: '🇰🇪',
            code: '254',
            name: 'Kenya'
        },
        forgotPinCode: undefined,
        submitting: false,
        openDialog: false,
        instantPlay: true,
        qrSessionId: null,
        verifyUserId: undefined
    })

    const { openDialog, currentPage, showPass, country, submitting, forgotPinCode, previousPage, instantPlay, qrSessionId, verifyUserId } = state,
        loginWith = instantPlay ? 'Phone' : state.loginWith,

        inputs = instantPlay ? ['Phone'] : currentPage === 'Sign Up' ? ['Username', 'Phone', 'Password', 'AgreeToTerms'] : currentPage === 'Sign In' ? [loginWith === 'Username' ? 'Username' : 'Phone', 'Password'] : currentPage === 'resetPass' ? ['NewPass', 'ConfirmPass'] : [loginWith === 'Username' ? 'Username' : 'Phone']

    const componentIsMounted = useRef(true)
    const qrSessionIdRef = useRef<string | null>(null)
    qrSessionIdRef.current = qrSessionId

    // The QR card sits inline at the bottom of the Sign In form at all times (no button to
    // reveal it) - a session is opened as soon as that page is shown, and stays live even while
    // the user types into the form above it.
    useEffect(() => {
        if (currentPage !== 'Sign In' || qrSessionId) return
        const sessionId = crypto.randomUUID()
        setState(s => ({ ...s, qrSessionId: sessionId }))
        sendSocketData({ action: 'userConnected', sessionId })
    }, [currentPage])

    useEffect(() => {
        const unsubscribeMessage = onSocketMessage((data: any) => {
            if (data.action === 'qrLogin' && setRedux) {
                setRedux({ ...data, User: data.user || data.User })
                navigate('/home')
            }
        })
        // A dropped/reconnected socket loses the server's registration of this sessionId - if
        // the user is still waiting on the QR screen, re-announce so the mobile confirmation can
        // still reach this tab.
        const unsubscribeOpen = onSocketOpen(() => {
            if (qrSessionIdRef.current)
                sendSocketData({ action: 'userConnected', sessionId: qrSessionIdRef.current })
        })
        return () => {
            unsubscribeMessage()
            unsubscribeOpen()
        }
    }, [])

    const changeInput = (input: string, obj: any) => {
        let Input = { ...(state as any)[input] }
        Input = { ...Input, ...obj }
        setState({
            ...state,
            [input]: Input,
            submitting: false
        })
    }

    const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const data = new FormData(event.currentTarget);
        const obj: any = {}

        data.forEach((value, key) => {
            const trimmedValue = typeof value === 'string' ? value.trim() : value
            obj[key] = key === 'Phone' ? buildPhone(country.code, String(trimmedValue)) : trimmedValue
        })
        if (data.has('Phone') && !obj.Phone)
            changeInput('Phone', { error: 'Enter a valid phone number.' })
        else if (!(state as any).AgreeToTerms.value && currentPage === 'Sign Up')
            changeInput('AgreeToTerms', { error: 'You need to agree to the terms and conditions.' })
        else {
            setState({
                ...state,
                submitting: true
            })
            const datToSend = {
                controller: 'Users',
                action: instantPlay ? 'instantPlay' : currentPage,
                forgotPinCode,
                userId: verifyUserId || User?._id,
                ...obj,
                ...(currentPage === 'Sign Up' && { country: country.name })
            }
            Api(datToSend).then((resp: any) => {
                // showHideLoader(false)
                const { error, field, message, User } = resp
                if (componentIsMounted.current) {
                    if (error) {
                        changeInput(error.field, { error: error.message })
                        // emitEvent('toast', { message: error.message, type: 'error' });
                    }

                    else if (currentPage === 'resetPass') {
                        // EventsEmit('modal', { action: 'toastMsg', message, type: 'success' })
                        setState({
                            ...state,
                            currentPage: 'Sign In',
                            showPass: false,
                            previousPage: null,
                            ...initialInputs
                        })
                    }
                    else {
                        if (resp.loggedIn && setRedux) {
                            setRedux({ ...resp, User: resp.user || resp.User })
                            navigate('/home')
                        } else {
                            if (setRedux)
                                setRedux({ User })
                            setState({
                                ...state,
                                currentPage: 'codeVerification',
                                previousPage: currentPage,
                                verifyUserId: User?._id,
                                ...initialInputs
                            })
                        }
                    }
                }


            }).catch((err) => {
                setState({
                    ...state,
                    submitting: false
                })
            })
        }
    }

    const heading = instantPlay && currentPage === 'Sign In'
        ? { title: 'Welcome to SpotPool', subtitle: 'Enter your phone number to start playing' }
        : currentPage === 'Sign In'
            ? { title: 'Welcome back', subtitle: 'Sign in to continue to SpotPool' }
            : currentPage === 'Sign Up'
                ? { title: 'Create your account', subtitle: 'Join SpotPool and start playing' }
                : currentPage === 'Forgot Password'
                    ? { title: 'Reset your password', subtitle: "We'll send you a code to confirm it's you" }
                    : { title: 'Set new password', subtitle: 'Choose a strong new password' }

    return (
        <>
            <style>{`
                .auth-input .MuiOutlinedInput-root { border-radius: 12px; }
                .auth-input .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline { border-color: ${PRIMARY}; }
                .auth-input label.Mui-focused { color: ${PRIMARY}; }
            `}</style>
            <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: '#fff' }}>
                {/* Left branding panel */}
                <Box sx={{
                    display: { xs: 'none', md: 'flex' },
                    width: '42%',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    background: `linear-gradient(160deg, #eefaf3 0%, #b9e3cf 50%, ${PRIMARY} 100%)`,
                    p: 6,
                    position: 'relative',
                    overflow: 'hidden'
                }}>
                    <Box sx={{ position: 'absolute', top: -100, right: -100, width: 350, height: 350, borderRadius: '50%', background: 'rgba(255,255,255,.15)', pointerEvents: 'none' }} />
                    <Box sx={{ position: 'absolute', bottom: -80, left: -80, width: 280, height: 280, borderRadius: '50%', background: 'rgba(255,255,255,.12)', pointerEvents: 'none' }} />

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        <img src={logo} style={{ height: 44, width: 44, borderRadius: '50%', objectFit: 'cover' }} />
                        <Typography sx={{ fontWeight: 800, fontSize: 22, color: PRIMARY_DARK }}>SpotPool</Typography>
                    </Box>

                    <Box>
                        <Typography sx={{ fontSize: { md: 32, lg: 40 }, fontWeight: 800, color: '#0b2e20', lineHeight: 1.2, mb: 2, textAlign: 'left' }}>
                            Play more pool, worry less about the tab.
                        </Typography>
                        <Typography sx={{ fontSize: 16, color: '#0b3d29', mb: 5, lineHeight: 1.6, opacity: 0.85, textAlign: 'left' }}>
                            Find a table, pay per game, and track every match - all from your phone.
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                            {SIDE_FEATURES.map(f => (
                                <Box key={f.text} sx={{ display: 'flex', alignItems: 'center', gap: 1.5, bgcolor: 'rgba(255,255,255,.6)', borderRadius: 3, px: 2.5, py: 1.5 }}>
                                    <Typography sx={{ fontSize: 20 }}>{f.icon}</Typography>
                                    <Typography sx={{ fontSize: 14, fontWeight: 600, color: '#0b2e20' }}>{f.text}</Typography>
                                </Box>
                            ))}
                        </Box>
                    </Box>

                    <Typography sx={{ fontSize: 12, color: '#0b3d29', opacity: 0.8, textAlign: 'left' }}>
                        © {new Date().getFullYear()} SpotPool. All rights reserved.
                    </Typography>
                </Box>

                {/* Right form panel */}
                <Box sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    bgcolor: '#fff',
                    p: { xs: 3, sm: 6 },
                    overflowY: 'auto'
                }}>
                    <Box sx={{ display: { xs: 'flex', md: 'none' }, alignItems: 'center', gap: 1, mb: 4 }}>
                        <img src={logo} style={{ height: 40, width: 40, borderRadius: '50%', objectFit: 'cover' }} />
                        <Typography sx={{ fontWeight: 800, fontSize: 20, color: PRIMARY }}>SpotPool</Typography>
                    </Box>

                    <Box sx={{ width: '100%', maxWidth: 420 }}>
                        <Show>
                            <Show.When isTrue={currentPage === codeVer}>
                                <CodeVerification
                                    page={previousPage as Page}
                                    loginWith={loginWith}
                                    goBack={() => setState({
                                        ...state,
                                        currentPage: previousPage as Page
                                    })
                                    }
                                    goToNextPage={(data: any) => setState({
                                        ...state,
                                        ...data,
                                        previousPage: state.currentPage
                                    })}
                                    User={User}
                                    userId={verifyUserId}
                                    setRedux={setRedux}
                                />
                            </Show.When>
                            <Show.Else>
                                <Fragment>
                                    {/* Heading */}
                                    <Box sx={{ mb: 4, textAlign: { xs: 'center', md: 'left' } }}>
                                        <Show>
                                            <Show.When isTrue={currentPage === 'Forgot Password'}>
                                                <IconButton
                                                    onClick={() => setState({ ...state, currentPage: 'Sign In' })}
                                                    sx={{ mb: 1, ml: { xs: 0, md: -1 } }}
                                                >
                                                    <ArrowBackOutlined />
                                                </IconButton>
                                            </Show.When>
                                        </Show>
                                        <Typography sx={{ fontSize: { xs: 24, sm: 28 }, fontWeight: 800, color: '#111827' }}>
                                            {heading.title}
                                        </Typography>
                                        <Typography sx={{ fontSize: 15, color: '#6b7280', mt: 0.5 }}>
                                            {heading.subtitle}
                                        </Typography>
                                    </Box>

                                    <Box component="form" sx={{ width: '100%' }} onSubmit={onSubmit}>
                                        <Show>
                                            <Show.When isTrue={!instantPlay && ['Sign In', 'Forgot Password'].includes(currentPage)}>
                                                <Typography
                                                    onClick={() => setState({ ...state, openDialog: true })}
                                                    sx={{
                                                        display: 'flex',
                                                        marginBottom: 2,
                                                        color: 'primary.main',
                                                        alignSelf: 'start',
                                                        fontWeight: 'bold'
                                                    }}>{currentPage === 'Sign In' ? 'Sign In with' : 'Check account by'}
                                                    <span style={{
                                                        display: 'flex',
                                                        textDecoration: 'underline',
                                                        alignItems: 'center',
                                                        marginLeft: 4
                                                    }}
                                                    >{loginWith}<ArrowDropDown /></span> </Typography>
                                            </Show.When>
                                        </Show>
                                        <Grid container spacing={2}>
                                            {
                                                inputs.map((input, i: number) => {
                                                    const { value, error, field, type, label } = (state as any)[input]
                                                    return (
                                                        <Grid
                                                            item
                                                            xs={12}
                                                            key={field}
                                                        >
                                                            <Show>
                                                                <Show.When isTrue={type === 'checkbox'}>
                                                                    <FormControlLabel
                                                                        control={<Checkbox
                                                                            value={value}
                                                                            color="primary"
                                                                            name={field}
                                                                            sx={{ color: 'grey' }}
                                                                            onChange={(e) => {
                                                                                changeInput(field, { error: null, value: e.target.checked })
                                                                            }}
                                                                        />}
                                                                        label={<Typography
                                                                            variant='body1' >I have read and agreed to the <a
                                                                                href='/terms_and_conditions'
                                                                                style={{ textDecoration: 'none' }}
                                                                            >Terms and Conditions</a> and <a
                                                                                href='policies'
                                                                                style={{ textDecoration: 'none' }}
                                                                            >Privacy Policies</a></Typography>}

                                                                    />
                                                                    <Show>
                                                                        <Show.When isTrue={Boolean(error)}>
                                                                            <Typography color={'error'} sx={{ fontSize: 14 }}>*{error}</Typography>
                                                                        </Show.When>
                                                                    </Show>
                                                                </Show.When>
                                                                <Show.Else>
                                                                    <TextField
                                                                        className="auth-input"
                                                                        variant='outlined'
                                                                        autoComplete="given-name"
                                                                        name={field}
                                                                        required
                                                                        fullWidth
                                                                        label={label}
                                                                        type={type === 'password' ? (showPass ? 'text' : type) : type}
                                                                        autoFocus={i === 0}
                                                                        error={Boolean(error)}
                                                                        helperText={error}
                                                                        onFocus={() => changeInput(field, { error: null })}
                                                                        InputProps={{
                                                                            startAdornment: (
                                                                                input === 'Phone' && (
                                                                                    <InputAdornment position="start">
                                                                                        <PhoneInput
                                                                                            country={'ke'}
                                                                                            value={state.country.code}
                                                                                            onChange={(value, country: any) => setState({
                                                                                                ...state,
                                                                                                country: {
                                                                                                    flag: country.countryCodeEmoji,
                                                                                                    code: country.dialCode,
                                                                                                    name: country.name
                                                                                                }
                                                                                            })}

                                                                                            inputStyle={{ border: 'none', outline: 'none', width: 85, backgroundColor: 'transparent' }}
                                                                                            dropdownStyle={{ top: 'auto', bottom: 0, display: 'flex', flexDirection: 'column', alignItems: 'start', width: 380 }}
                                                                                            buttonStyle={{
                                                                                                backgroundColor: 'transparent', border: 'none', transition: 'none',

                                                                                            }}

                                                                                        />



                                                                                    </InputAdornment>)
                                                                            ),

                                                                            endAdornment:
                                                                                (
                                                                                    ['Password', 'ConfirmPass', 'NewPass'].includes(field) ?
                                                                                        <InputAdornment position="end">
                                                                                            <IconButton
                                                                                                onClick={() => setState({
                                                                                                    ...state,
                                                                                                    showPass: !showPass
                                                                                                })}
                                                                                            >
                                                                                                {
                                                                                                    showPass ?
                                                                                                        <VisibilityOff /> :
                                                                                                        <RemoveRedEye />
                                                                                                }
                                                                                            </IconButton>
                                                                                        </InputAdornment> :
                                                                                        <Fragment />
                                                                                )
                                                                        }}
                                                                    />
                                                                </Show.Else>
                                                            </Show>
                                                            <Show>
                                                                <Show.When isTrue={currentPage === 'Sign In' && input === 'Password' && !instantPlay}>
                                                                    <Box sx={{
                                                                        display: 'flex',
                                                                        justifyContent: 'flex-end',
                                                                        mt: 1
                                                                    }}
                                                                    >
                                                                        <Button
                                                                            sx={{
                                                                                textTransform: 'none',
                                                                                fontSize: 13,
                                                                                color: PRIMARY,
                                                                                p: 0,
                                                                                minWidth: 0
                                                                            }}
                                                                            onClick={() => setState({ ...state, currentPage: 'Forgot Password' })}
                                                                        >Forgot Password?</Button>
                                                                    </Box>
                                                                </Show.When>
                                                            </Show>
                                                        </Grid>
                                                    )
                                                }

                                                )
                                            }
                                        </Grid>
                                        <FormControlLabel
                                            sx={{ mt: 3, mb: 1 }}
                                            control={<Checkbox
                                                checked={instantPlay}
                                                color="primary"
                                                name={'playWithoutAccount'}
                                                sx={{ color: 'grey' }}
                                                onChange={(e) => {
                                                    setState({ ...state, instantPlay: e.target.checked })
                                                }}
                                            />}
                                            label={<Typography variant='body1'>Continue without creating account </Typography>}
                                        />
                                        <LoadingButton
                                            type="submit"
                                            fullWidth
                                            variant="contained"
                                            sx={{
                                                mt: 2, mb: 2, textTransform: 'none',
                                                bgcolor: PRIMARY, borderRadius: '12px', py: 1.4,
                                                fontSize: 15, fontWeight: 700,
                                                '&:hover': { bgcolor: PRIMARY_DARK },
                                                '&.MuiLoadingButton-loading': { bgcolor: `${PRIMARY}99` }
                                            }}
                                            loading={submitting}

                                        >
                                            {instantPlay ? 'Continue' : currentPage === 'Forgot Password' ? 'Next' : currentPage}
                                        </LoadingButton>

                                        <Show>
                                            <Show.When isTrue={!instantPlay}>
                                                <Box sx={{ textAlign: 'center' }}>
                                                    <Typography component="span" sx={{ fontSize: 14, color: '#6b7280' }}>
                                                        {currentPage === 'Sign In' ? 'Don\'t have an account? ' : currentPage === 'Sign Up' ? 'Already have an account? ' : ''}
                                                    </Typography>
                                                    <Link
                                                        component="button"
                                                        type="button"
                                                        onClick={() => setState({
                                                            ...state,
                                                            currentPage: currentPage === 'Sign In' ? 'Sign Up' : 'Sign In',
                                                            ...initialInputs,
                                                            showPass: false
                                                        })}
                                                        sx={{ fontSize: 14, fontWeight: 700, color: PRIMARY, textDecoration: 'none', '&:hover': { textDecoration: 'underline' }, cursor: 'pointer' }}
                                                    >
                                                        {['Sign In', 'Sign Up'].includes(currentPage) ? (currentPage === 'Sign In' ? 'Sign Up' : 'Sign In') : 'Back to Sign In'}
                                                    </Link>
                                                </Box>
                                            </Show.When>
                                        </Show>

                                        {/* QR code login card */}
                                        <Show>
                                            <Show.When isTrue={currentPage === 'Sign In'}>
                                                <Fragment>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, my: 3 }}>
                                                        <Box sx={{ flex: 1, height: '1px', bgcolor: '#e5e7eb' }} />
                                                        <Typography sx={{ fontSize: 12, color: '#9ca3af', fontWeight: 500 }}>or login with QR code</Typography>
                                                        <Box sx={{ flex: 1, height: '1px', bgcolor: '#e5e7eb' }} />
                                                    </Box>

                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 3, p: 2.5, borderRadius: 3, bgcolor: '#f6faf8', border: '1px solid #e5e7eb' }}>
                                                        <Box sx={{ flexShrink: 0, p: 1.5, bgcolor: '#fff', borderRadius: 2, border: '1px solid #e5e7eb', display: 'flex', alignItems: 'center', justifyContent: 'center', width: 110, height: 110 }}>
                                                            <Show>
                                                                <Show.When isTrue={Boolean(qrSessionId)}>
                                                                    <QRCode value={`${QR_LOGIN_PREFIX}${qrSessionId}`} size={88} fgColor={PRIMARY_DARK} />
                                                                </Show.When>
                                                                <Show.Else>
                                                                    <CircularProgress size={32} sx={{ color: PRIMARY }} />
                                                                </Show.Else>
                                                            </Show>
                                                        </Box>
                                                        <Box sx={{ flex: 1, textAlign: 'left' }}>
                                                            <Typography sx={{ fontWeight: 700, fontSize: 13.5, color: '#111827', mb: 0.8 }}>
                                                                Login with QR Code
                                                            </Typography>
                                                            {['Open the SpotPool app', 'Go to Profile → Log In on Web', 'Point your camera here'].map((step, i) => (
                                                                <Box key={step} sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                                                                    <Box sx={{ width: 18, height: 18, borderRadius: '50%', bgcolor: PRIMARY, color: '#fff', fontSize: 10, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                                                        {i + 1}
                                                                    </Box>
                                                                    <Typography sx={{ fontSize: 12.5, color: '#6b7280' }}>{step}</Typography>
                                                                </Box>
                                                            ))}
                                                        </Box>
                                                    </Box>
                                                </Fragment>
                                            </Show.When>
                                        </Show>
                                    </Box>
                                </Fragment>
                            </Show.Else>
                        </Show>
                    </Box>
                </Box>
            </Box>
            <Show>
                <Show.When isTrue={openDialog}>
                    <ChangeSignInWith
                        close={() => setState({ ...state, openDialog: false })}
                        onOptionSelect={(loginWith: 'Username' | 'Phone') => setState({
                            ...state,
                            openDialog: false,
                            loginWith
                        })}
                    />
                </Show.When>
            </Show>
        </>
    )
}

export default Connect(mapStateToProps, mapDispatchToProps)(Auth);
